import app from 'flarum/forum/app';
import Avatar from 'flarum/common/components/Avatar';
import username from 'flarum/common/helpers/username';
import { safeFileUrl } from './url';
import userLink from './userLink';

/**
 * Identidade do bot do chat. Não há conta por trás, de propósito: uma conta
 * apareceria em listas de membros e menções e poderia ser logada. O bot é só um
 * rótulo de autor, definido por configurações.
 */

/** Sem configuração, usa o nome do fórum. */
export function botName() {
  const configured = app.forum.attribute('ramon-chat.botName');
  if (typeof configured === 'string' && configured.trim() !== '') {
    return configured.trim();
  }
  return app.translator.trans('ramon-chat.forum.bot.default_name', {}, true);
}

/**
 * Arquivo enviado vence a URL digitada. Os dois são guardados: removendo o upload,
 * a URL externa volta. A URL passa pela mesma allowlist de protocolo das imagens
 * do chat.
 */
export function botAvatarUrl() {
  const uploaded = app.forum.attribute('ramon-chat.botAvatarPath');
  if (typeof uploaded === 'string' && uploaded.trim() !== '') {
    return "".concat(app.forum.attribute('assetsBaseUrl'), "/").concat(uploaded.trim());
  }
  const url = app.forum.attribute('ramon-chat.botAvatarUrl');
  return safeFileUrl(url) || null;
}

/**
 * Avatar no formato do core, para ocupar a mesma calha. Sem imagem, usa a inicial
 * num disco colorido, como o core faz com usuário sem avatar.
 */
export function botAvatar(className) {
  if (className === void 0) {
    className = 'Avatar';
  }
  const url = botAvatarUrl();
  const name = botName();
  if (url) {
    return m("img", {
      className: className,
      src: url,
      alt: name,
      loading: "lazy"
    });
  }
  return m("span", {
    className: "".concat(className, " Avatar--bot"),
    "aria-label": name
  }, name.charAt(0).toUpperCase());
}

/**
 * Avatar de uma mensagem, de qualquer autor. Mensagem do bot não tem `user_id`,
 * então renderizar `message.user()` direto a mostraria como conta apagada.
 */
export function authorAvatar(message, className) {
  if (className === void 0) {
    className = 'Avatar';
  }
  return message.isBot() ? botAvatar(className) : m(Avatar, {
    user: message.user(),
    className: className
  });
}

/** Nome do autor em texto simples, para resumos e linhas curtas. */
export function authorName(message) {
  return message.isBot() ? botName() : username(message.user());
}

/** Nome do autor com link para o perfil; o bot não tem perfil. */
export function authorLink(message) {
  return message.isBot() ? botName() : userLink(message.user());
}
flarum.reg.add('ramon-chat', 'forum/utils/bot', { botName: botName,botAvatarUrl: botAvatarUrl,botAvatar: botAvatar,authorAvatar: authorAvatar,authorName: authorName,authorLink: authorLink, });